import Icon from "@mui/icons-material/EventNote";
import RazaEventsList from "./list";
import RazaEventsCreate from "./RazaEventsCreate";
import RazaEventOhbatEdit from "./RazaEventOhbatEdit";
import RazaEventsShow from "./RazaEventsShow";

export default {
  list: RazaEventsList,
  create: RazaEventsCreate,
  edit: RazaEventOhbatEdit,
  show: RazaEventsShow,
  icon: Icon,
  label: "Raza events",
  options: { label: "Raza events" },
  name: "raza-events",
};
